<template>
  <div class="filter-card-my-offered">
    <div class="filter-content">
      <div class="name-filter">
        {{ $t('components.filter_my_offereds.title_filter_by_material_type') }}
      </div>
      <div class="content-chip">
        <div
          v-for="(value, index) in byMaterialTypeOptions"
          :key="index"
          :class="['chip-filter', materialSelected(value)]"
          @click="selectMaterialType(value)"
        >
          {{ value }}
        </div>
      </div>
    </div>

    <div class="filter-content filter-content-year">
      <div class="name-filter">
        {{ $t('components.filter_my_offereds.title_filter_by_year') }}
      </div>
      <div class="content-select">
        <custom-select
          :value="filters.by_year"
          :items="byYearOptions"
          :placeholder="$t('components.filter_my_offereds.by_year_options.all')"
          :sync-selected-from-value="true"
          class="year-select"
          @change="selectYear"
        />
      </div>
    </div>

    <div class="filter-content">
      <div class="name-filter">
        {{ $t('components.filter_my_offereds.title_filter_by_status') }}
      </div>
      <div class="content-chip">
        <div
          v-for="(value, index) in byStatusOptions"
          :key="index"
          :class="['chip-filter', byStatusSelected(value)]"
          @click="selectStatus(value)"
        >
          {{ $t(`components.filter_my_offereds.by_status_options.${value}`) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomSelect from '@/components/selects/CustomSelect.vue';

export default {
  name: 'FilterMyOffereds',
  components: {
    CustomSelect,
  },
  props: {
    availableYears: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      byMaterialTypeOptions: ['Papel', 'Plastico', 'Metal', 'Vidro'],
      byStatusOptions: ['active', 'pending_payment', 'sold'],
      filters: {
        filter_by_material_type: [],
        by_status: [],
        by_year: null,
      },
    };
  },
  computed: {
    byYearOptions() {
      return [
        {
          text: this.$t('components.filter_my_offereds.by_year_options.all'),
          value: null,
        },
        ...this.availableYears.map((year) => ({
          text: String(year),
          value: String(year),
        })),
      ];
    },
  },
  methods: {
    emitFilters() {
      const filters = {
        ...this.filters,
      };

      if (!filters.by_year) {
        delete filters.by_year;
      }

      this.$emit('change', filters);
    },
    selectMaterialType(value) {
      const index = this.filters.filter_by_material_type.indexOf(value);

      if (index >= 0) {
        this.filters.filter_by_material_type.splice(index, 1);
      } else {
        this.filters.filter_by_material_type.push(value);
      }

      this.emitFilters();
    },

    selectYear(value) {
      this.filters.by_year = value;
      this.emitFilters();
    },

    selectStatus(value) {
      const index = this.filters.by_status.indexOf(value);

      if (index >= 0) {
        this.filters.by_status.splice(index, 1);
      } else {
        this.filters.by_status.push(value);
      }

      this.emitFilters();
    },

    materialSelected(value) {
      return this.filters.filter_by_material_type.includes(value) ? 'chip-selected' : '';
    },

    byStatusSelected(value) {
      return this.filters.by_status.includes(value) ? 'chip-selected' : '';
    },
  },
};
</script>
<style lang="scss" scoped>
.filter-card-my-offered {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 32px;
  flex-wrap: wrap;

  .filter-content {
    flex: 0 0 auto;

    .name-filter {
      text-align: start;
      font-weight: 600;
      margin-bottom: 12px;
    }

    .content-chip {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      width: fit-content;

      .chip-filter {
        background-color: transparent;
        border: $color_text_chip_filter solid 1px;
        border-radius: 24px;
        height: 30px;
        padding: 0 16px;
        font-size: 0.875em;
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: $color_text_chip_filter;

        &.chip-selected {
          background-color: $color_primary;
          border-color: $color_primary;
          color: white;
        }
      }
    }

    .content-select {
      width: fit-content;

      .year-select {
        width: 180px;
        margin-bottom: 0;
        background-color: transparent;
        border: $color_text_chip_filter solid 1px;
        border-radius: 24px;
        color: $color_text_chip_filter;
        padding: 0 16px;

        ::v-deep .select {
          min-height: 28px;

          span {
            font-size: 0.875em;
            font-weight: 600;
            white-space: nowrap;
          }

          .arrow {
            font-size: 20px !important;
            margin-right: 0 !important;
          }
        }

        ::v-deep .v-divider {
          display: none;
        }

        ::v-deep .expanded {
          top: calc(100% + 8px);
          overflow: hidden;
          border-radius: 12px;
        }
      }
    }

    &.filter-content-year {
      width: 200px;
    }
  }
}
</style>
